import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function HistoryIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15">
      <path
        fill="#6674A6"
        fillRule="evenodd"
        d="M12.277 10.23l.54.27L7.5 13.158 2.184 10.5l.54-.27-1.342-.671-.987.494a.5.5 0 0 0 0 .894l6.614 3.307c.309.155.674.155.983 0l6.614-3.307a.5.5 0 0 0 0-.894l-.987-.494-1.342.671zm0-3l.54.27L7.5 10.158 2.184 7.5l.54-.27-1.342-.671-.987.494a.5.5 0 0 0 0 .894l6.614 3.307c.309.155.674.155.983 0l6.614-3.307a.5.5 0 0 0 0-.894l-.987-.494-1.342.671zm2.329-3.177a.5.5 0 0 1 0 .894L7.992 8.254a1.097 1.097 0 0 1-.983 0L.395 4.947a.5.5 0 0 1 0-.894L7.053.724a1 1 0 0 1 .895 0l6.658 3.329zM7.5 1.842L2.184 4.5 7.5 7.158 12.817 4.5 7.5 1.842zM15 0v15V0zM0 15V0v15z"
      />
    </SvgIcon>
  )
}
